import React from "react";
import "../Components/styles/Skill.css";

const Skill = (props) => {
  return (
    <div className="skill">
      <p className="skill-text">{props.skill}</p>
    </div>
  );
};

export default Skill;
